import React, { useMemo } from "react";
import { Chart } from "react-google-charts";
import { ChartWrapperOptions } from "react-google-charts/dist/types";

import { ViewOfTheRoom } from "../../api";
import { divergingScheme4 as colorArray, duo as duoColors, getColor } from "../../common/helpers/colors";

import Loader from "../../common/components/Loader";
import Legend from "./ValueInTheRoomLegend";

interface ValueInTheRoomColumnChartProps {
  view: ViewOfTheRoom;
}

const ValueInTheRoomColumnChart = ({ view }: ValueInTheRoomColumnChartProps) => {

  const colors = (totalValues => {
    if (totalValues === 2) {
      return duoColors;
    }
    const arr: string[] = [];
    for (let i = 0; i < totalValues; i++) {
      arr.push(getColor(colorArray, i, totalValues));
    }
    return arr;
  })(view.data[0].values.length);

  const options: ChartWrapperOptions["options"] = {
    titlePosition: "none",
    height: 350,
    chartArea: { width: "60%", height: "60%" },
    isStacked: true,
    legend: "none",
    colors,
    hAxis: {
      title: view.axes ? view.axes[0] || void 0 : void 0,
      titleTextStyle: {
        fontSize: 12,
        color: "#ffffff",
        italic: false,
      },
      textStyle: {
        color: "#ffffff",
      },
      maxTextLines: 10,
      slantedText: true,
      slantedTextAngle: 90,
    },
    vAxis: {
      title: view.axes ? view.axes[1] || void 0 : void 0,
      titleTextStyle: {
        fontSize: 12,
        color: "#ffffff",
        italic: false,
      },
      textStyle: {
        color: "#ffffff",
      }
    },
    backgroundColor: "transparent"
  };

  const data = useMemo(() => {
    const arr: any[] = [["Name", ...(view.labels ?? [])]];
    arr.push(...view.data.map(x => [x.name, ...x.values]));
    return arr;
  }, [view]);

  return (
    <>
      <div className="pb-2 position-relative w-100">
        <Chart
          chartType="ColumnChart"
          width="100%"
          data={data}
          options={options}
          loader={
            <div style={{ width: "100%", height: options.height }}>
              <Loader show />
            </div>
          }
        />
      </div>
      {!!view.labels && (
        <Legend labels={view.labels} colors={colors} />
      )}
    </>
  );
};

export default ValueInTheRoomColumnChart;
